import styled from "styled-components";
import { Assets } from "../../common/styles/assets";
import { Form } from "formik";


export const FormSignin = styled(Form)`
  width: 350px;
  margin-top: 120px;
  background-color:${Assets.backgroundForm};
  border: 1px solid ${Assets.secondaryColor};
  border-radius: ${Assets.borderRadiusForm};
  padding: 30px;
  @media (max-width: 768px) {     
    margin-top: 100px;
  }
`;

export const ResetPassword = styled.a`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;  
  text-decoration: none;
  margin-bottom: 10px;  
  cursor: pointer;
  &:hover {
    color: ${Assets.primaryColor};
  }
`;

export const Register = styled.a`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Assets.primaryColor};
  font-size: 14px;  
  text-decoration: none;  
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: ${Assets.primaryColor};
  }
`;